import { render, staticRenderFns } from "./ExibirCargo.vue?vue&type=template&id=1646999e&scoped=true&"
import script from "./ExibirCargo.vue?vue&type=script&lang=js&"
export * from "./ExibirCargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1646999e",
  null
  
)

export default component.exports